export enum SeriesType {
  OK = 'sum_okpoint',
  NG = 'sum_ngpoint',
  WARNING = 'sum_warningpoint',
  OVER = 'sum_overpoint'
}

export enum SearchType {
  WORK = 0, // 検査ごと
  HOUR = 1, // 1時間ごと
  DAY = 2, // 1日ごと
  MONTH = 3 // 1ヶ月ごと
}

export interface SearchConditions {
  selectDateFrom: string;
  selectDateTo: string;
  work: string[];
  deviceid: string[];
  judge: number;
  searchType: SearchType;
}
